import React from 'react';
import { X, Star } from 'lucide-react';

const AgentDialog = ({ customer, form, setForm, onConfirm, onClose, loading }) => {
  if (!customer) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm">
        <div className="p-5 border-b flex justify-between items-center">
          <h3 className="font-bold text-gray-800 flex items-center gap-2">
            <Star className="w-5 h-5 text-purple-600" />
            {customer.is_agent ? '取消代理' : '开通代理'}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-5 space-y-4">
          <p className="text-sm text-gray-600">客户：<span className="font-medium">{customer.name || customer.username}</span></p>
          {form.is_agent && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">佣金分成比例 %</label>
              <div className="grid grid-cols-4 gap-2">
                {[30, 40, 50, 60].map(r => (
                  <button key={r} type="button"
                    onClick={() => setForm({ ...form, commission_rate: r })}
                    className={`py-2 rounded-lg text-sm font-medium border transition-colors ${
                      form.commission_rate === r
                        ? 'bg-purple-500 text-white border-purple-500'
                        : 'bg-white text-gray-700 border-gray-300 hover:border-purple-400'
                    }`}>
                    {r}%
                  </button>
                ))}
              </div>
              <p className="text-xs text-gray-400 mt-2">
                推广用户每购买一次 VIP，推广人获得 {form.commission_rate}% 佣金
              </p>
            </div>
          )}
          {!form.is_agent && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <p className="text-sm text-red-600">取消后该用户的优惠码将失效，已获得的佣金不受影响。</p>
            </div>
          )}
        </div>
        <div className="p-5 border-t flex gap-3">
          <button onClick={onClose}
            className="flex-1 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50">
            取消
          </button>
          <button onClick={onConfirm} disabled={loading}
            className={`flex-1 py-2 rounded-lg text-sm font-medium text-white transition-colors ${
              form.is_agent ? 'bg-purple-500 hover:bg-purple-600' : 'bg-red-500 hover:bg-red-600'
            } disabled:opacity-50`}>
            {loading ? '处理中...' : form.is_agent ? '确认开通' : '确认取消'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentDialog;